<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">门诊服务 (针对持有韩国国民健康保险或未有其待遇的国际患者)</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">步骤 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">预约</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">国际诊疗中心</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">咨询您的医生</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">完成支付</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">进行检验或领取 处方药物</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">预约</h4>
            <p class="depth">
                请拨打 +82-6986-3100 <br>
                电子邮件 eumcint@gmail.com <br>
                在线申请预约 <br>
                请到门诊就诊（备注：无法保证能预约当天就诊）
            </p>
            <h4 class="depth bullet02">来国际医疗保健中心就诊</h4>
            <p class="depth">
                请到一楼国际诊疗中心。访问时须携带居留证或护照才可以进行挂号. 若有病历时，请提前10分钟到达并提交检查结果或光盘图像。如果您有医院的编号，请找事先安排好的医生进行诊疗.
            </p>
            <h4 class="depth bullet02">咨询您的医生</h4>
            <p class="depth">
                医生会给您讲解治疗方案，并根据情况若有需要时，将推荐其他的专科医生. 国际诊疗中心的护士或协调员将帮助您完成后续的诊疗预约.
            </p>
            <h4 class="depth bullet02">完成支付</h4>
            <p class="depth">
                治疗费用可以现金 (韩元) 或信用卡支付. 如果您需要换汇服务, 主楼B1的银行可以提供帮助. 根据我们医院的政策, 除了咨询之外的所有门诊检查和治疗都必须在预约前付费. 如果您需要将国际保险表格提交给您的保险公司, 请随身携带.
            </p>
            <h4 class="depth bullet02">进行检验或领取处方药物</h4>
            <p class="depth">
                付款后, 您可以按照要求接受所需检验. 请打印您的处方, 然后到药房取药.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>